export const SEGMENT_DEPLOYABLE_NAME = 'cardfinder';
export const SEGMENT_DEPLOYABLE_VERSION = '1.0.0';
export const SEGMENT_SKU_VIEWED_SOURCE = 'marketplace';
export const SEGMENT_SKU_VIEWED_PRODUCT_TYPE = 'credit_cards';
export const SEGMENT_SKU_VIEWED_LEVEL = 'offer';

export enum Cookie {
  GoogleAnalytics = '_ga',
  DeviceId = 'cookie_id',
}

export enum EventType {
  ElementImpression = 'element_impression',
  ElementInteracted = 'element_interacted',
  FormImpression = 'form_impression',
  FormSubmit = 'form_submit',
  FormCancelled = 'form_cancelled',
  PageImpression = 'page_impression',
  ProductImpression = 'product_impression',
  ShoppingGenericUpdated = 'shopping_generic_updated',
  UserNavigated = 'user_navigated',
  RecsOffersImpression = 'cc_recs_offers_impression',
  CcRecsSubmit = 'cc_recs_submit',
  CCTravelRecsSubmit = 'cc_travel_recs_submit',
  CCCashBackRecsSubmit = 'cc_cashback_recs_submit',
  CCDebtRecsSubmit = 'cc_debt_recs_submit',
  CCPurchaseRecsSubmit = 'cc_purchase_recs_submit',
  CCBuildCreditRecsSubmit = 'cc_build_credit_recs_submit',
  MembershipEnrollmentChanged = 'membership_enrollment_changed',
  EmailAddressUpdated = 'email_address_updated',
  PasswordUpdated = 'password_updated',
  RegistrationCtaImpression = 'registration_cta_impression',
  BestBetsImpression = 'cf_best_bets_impression',
}

export enum FormName {
  Flow = 'cc_curated_offers',
  WelcomeBack = 'cc_curated_offers_flow_retake',
  QuickEdit = 'cc_recs_quickedit',
}

export enum EntityName {
  BackButtonClick = 'cc_curated_offers_back',
  CardfinderNullState = 'cardfinder_null_state',
  Flow = 'cc_recommend_flow',
  HideProductCard = 'hide_product_card',
  MatchResultsProduct = 'cc_match_results_product',
  QuickEdit = 'cc_recs_quickedit',
  RestoreProductCards = 'restore_product_cards',
  Results = 'cc_match_results_page',
  WelcomeBackRetake = 'cc_match_retake',
  Jump = 'cf_landing_pg',
  JumpDeserve = 'cf_landing_deserve',
  JumpCCBrands = 'cc_landing_cc_brands',
  JumpData = 'cc_landing_data',
  JumpHowItWorks = 'cf_landing_how_it_works',
  JumpPersRecsRatings = 'cf_landing_pers_recs_ratings',
  Register = 'cardfinder_register',
  BestBets = 'cf_best_bets_impression',
  SaveResults = 'cf_save_results',
  CcRecsOffersImpression = 'cc_recs_offers_impression',
}

export enum SectionName {
  JumpHeroCta = 'cf_landing_hero_cta',
  JumpDeserve = 'cf_landing_deserve',
  JumpCCBrands = 'cc_landing_cc_brands',
  JumpData = 'cc_landing_data',
  JumpHowItWorks = 'cf_landing_how_it_works',
  JumpPersRecsRatings = 'cf_landing_pers_recs_ratings',
  JumpBottomCta = 'cf_landing_bottom_cta',
}

export enum FinishType {
  ExternalApplication = 'external_application',
}

export enum LinkType {
  ApplyNowButton = 'APPLY_NOW_BUTTON',
  ProductName = 'PRODUCT_NAME',
  ProductImage = 'PRODUCT_IMAGE',
  RateAndFeesText = 'rates_and_fees_text',
}

export enum Monetizing {
  YesAssumed = 'yes_assumed',
  No = 'no',
}

export enum ProductType {
  CreditCards = 'credit_cards',
}

export enum TrkLocation {
  JumpPageHero = 'cf_landing_hero_cta',
  JumpPageBottom = 'cf_landing_bottom_cta',
}

export enum SegmentEventType {
  PageAction = 'Page Action',
}

export enum PageActionName {
  AirlineChoice = 'airlineChoice',
  Auth0 = 'auth0',
  AnnualFees = 'annualFees',
  CardDeposit = 'cardDeposit',
  CashBackBigPurchase = 'cashBackBigPurchase',
  CashBackPreference = 'cashBackPreference',
  CcCuratedOffersBack = 'cc_curated_offers_back',
  CcCuratedOffersCancel = 'cc_curated_offers_cancel',
  CcRecsSubmit = 'cc_recs_submit',
  CollegeStudent = 'collegeStudent',
  CreditScore = 'creditScore',
  CurrentBalanceCompany = 'currentBalanceCompany',
  FullDebt = 'fullDebt',
  HotelChoice = 'hotelChoice',
  HowLongToPayOffDebt = 'howLongToPayOffDebt',
  InternationalTravel = 'internationalTravel',
  IntroAPROrRewards = 'introAPROrRewards',
  IsBuildingCredit = 'isBuildingCredit',
  IsDebtCreditCard = 'isDebtCreditCard',
  LuxuryPerks = 'luxuryPerks',
  ManagingCategories = 'managingCategories',
  MonthlySpend = 'monthlySpend',
  PrimaryGoal = 'primaryGoal',
  PurchaseSpend = 'purchaseSpend',
  PurchaseSpendingCategories = 'purchaseSpendingCategories',
  RewardsAndPerks = 'rewardsAndPerks',
  SecurityDeposit = 'securityDeposit',
  SpecificAirlineOrHotel = 'specificAirlineOrHotel',
  SpendingCategories = 'spendingCategories',
  StudentSpendingCategories = 'studentSpendingCategories',
  TypeOfDebt = 'typeOfDebt',
  ApprovalOdds = 'cc_get_approval_odds',
}

export enum PageActionType {
  Input = 'input',
  Select = 'select',
  Submit = 'submit',
  Open = 'open',
}
